import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeft24, IcoChevronRight24 } from '@onefootprint/icons';
import { format } from 'date-fns';
import { motion } from 'framer-motion';
import IconButton from '../../../icon-button';
import { DirectionChange, type HeaderProps } from '../../date-selector-sheet.types';
import { getMoveVariants } from '../../date-selector-sheet.utils';
const Header = t0 => {
  const $ = _c(26);
  const {
    handleMonthChange,
    firstDayCurrentMonth,
    movingDirection,
    setMovingDirection
  } = t0;
  let t1;
  if ($[0] !== handleMonthChange || $[1] !== setMovingDirection) {
    t1 = newDirection => {
      handleMonthChange(newDirection);
      setMovingDirection(newDirection);
    };
    $[0] = handleMonthChange;
    $[1] = setMovingDirection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDirectionChange = t1;
  let t2;
  if ($[3] !== handleDirectionChange) {
    t2 = <IconButton aria-label="Previous month" onClick={() => handleDirectionChange(DirectionChange.previous)} icon={IcoChevronLeft24} />;
    $[3] = handleDirectionChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== firstDayCurrentMonth) {
    t3 = format(firstDayCurrentMonth, "MMMM yyyy");
    $[5] = firstDayCurrentMonth;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = movingDirection ? "initial" : false;
  const t5 = movingDirection ? "animate" : false;
  let t6;
  if ($[7] !== movingDirection) {
    t6 = movingDirection ? getMoveVariants(movingDirection) : {};
    $[7] = movingDirection;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 0.5
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== firstDayCurrentMonth) {
    t8 = format(firstDayCurrentMonth, "MMMM yyyy");
    $[10] = firstDayCurrentMonth;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <p className="text-label-2 text-primary">{t8}</p>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t9) {
    t10 = <motion.div className="pointer-events-none user-select-none" key={t3} initial={t4} animate={t5} exit="exit" variants={t6} transition={t7}>{t9}</motion.div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== handleDirectionChange) {
    t11 = <IconButton aria-label="Next month" onClick={() => handleDirectionChange(DirectionChange.next)} icon={IcoChevronRight24} />;
    $[20] = handleDirectionChange;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t2) {
    t12 = <div className="flex items-center justify-between h-10 px-1">{t2}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t2;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default Header;